import { MessageDescriptor } from 'react-intl';

import {
  SUGGESTION_CONFIDENCE,
  SuggestionConfidence,
} from '@savgroup-front-common/types/CompanyDirectory';

import messages from './messages';

export const CONFIDENCE_MESSAGES: Record<
  SuggestionConfidence,
  MessageDescriptor | undefined
> = {
  [SUGGESTION_CONFIDENCE.UNKNOWN]: undefined,
  [SUGGESTION_CONFIDENCE.LOW]: messages.confidenceLow,
  [SUGGESTION_CONFIDENCE.MEDIUM]: messages.confidenceMedium,
  [SUGGESTION_CONFIDENCE.HIGH]: messages.confidenceHigh,
};
